module.exports = __webpack_public_path__ + "static/media/4S.e1ae3152.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/4S.svg
// module id = 64
// module chunks = 0